import { ReactNode } from 'react';
import { Stack } from '../../../Stack';
import { GlobalSearchContainer, SubTitle, TableHeaderContainer, Title } from './styles';
import TableHeaderSearch from './TableHeaderSearch';

interface TableHeaderProps {
    globalSearch?: boolean | { placeholder: ReactNode };
    title?: ReactNode;
    subTitle?: ReactNode;
    rightSide?: ReactNode;
    onRowSelectionChange?: React.Dispatch<React.SetStateAction<{}>>;
}

const TableHeader = ({ globalSearch, title, subTitle, rightSide, onRowSelectionChange }: TableHeaderProps) => {
    const hasOneTitle = title || subTitle;

    return (
        <TableHeaderContainer>
            <Stack spacing="300" distribution={hasOneTitle ? 'space-between' : 'stretch'}>
                {hasOneTitle ? (
                    <Stack itemAlignment="center">
                        {title ? <Title hasSubTitle={!!subTitle}>{title}</Title> : null}
                        {subTitle ? <SubTitle>{subTitle}</SubTitle> : null}
                    </Stack>
                ) : null}
                {globalSearch || rightSide ? (
                    <GlobalSearchContainer spacing="100" alignment="end">
                        {globalSearch ? (
                            <TableHeaderSearch
                                onRowSelectionChange={onRowSelectionChange}
                                placeholder={typeof globalSearch === 'object' ? globalSearch.placeholder : undefined}
                            />
                        ) : null}
                        {rightSide ? <Stack spacing="100">{rightSide}</Stack> : null}
                    </GlobalSearchContainer>
                ) : null}
            </Stack>
        </TableHeaderContainer>
    );
};

export default TableHeader;
